import React, { type MutableRefObject } from 'react';

import { BeneficiariosTable } from '../../../../components';
import SeguradoBeneficiarioFormSection from '../../../../components/pagesComponents/vidaPageComponents/SeguradoBeneficiarioFormSection';
import type { SeguradoBeneficiarioFormValues } from '../../../../types/vida/cadastralMaintenance/beneficiarioFormTypes';
import type { NewInsuredFormValues } from '../../../../types/vida/cadastralMaintenance/newInsuredFormTypes';
import type { PersonFormSection, PersonFormSectionControl } from '../../../../types/vida/cadastralMaintenance/personFormTypes';
import type { BeneficiarioTableItem } from '../../../../types/vida/table/beneficiariosTableType';
import ConjuguePanelSection from './ConjuguePanelSection';

type SeguradoRelatedPanelsSectionProps = {
  formKey: string | number;
  isSaving?: boolean;
  canManageBeneficiarios?: boolean;
  canAddConjugue?: boolean;
  isBeneficiariosListActive: boolean;
  isBeneficiariosDetailActive: boolean;
  isConjugueScreenActive: boolean;
  isConjugueFormActive: boolean;
  beneficiariosRows: BeneficiarioTableItem[];
  selectedBeneficiario: BeneficiarioTableItem | null;
  beneficiarioDraft: SeguradoBeneficiarioFormValues | null;
  beneficiarioFormInitialValues: SeguradoBeneficiarioFormValues | null;
  conjugueDisplayValues: NewInsuredFormValues | null;
  conjugueSectionControlRef: MutableRefObject<PersonFormSectionControl | null>;
  onConjugueActiveSectionChange: (section: PersonFormSection) => void;
  onEditBeneficiario: (row: BeneficiarioTableItem) => void;
  onAddBeneficiario: () => void;
  onBeneficiarioValidityChange: (isValid: boolean) => void;
  onBeneficiarioValuesChange: (values: SeguradoBeneficiarioFormValues) => void;
  onAddConjugue: () => void;
  onEditConjugue: () => void;
  onConjugueValidityChange: (isValid: boolean) => void;
  onConjugueValuesChange: (values: NewInsuredFormValues) => void;
};

const SeguradoRelatedPanelsSection: React.FC<SeguradoRelatedPanelsSectionProps> = ({
  formKey,
  isSaving = false,
  canManageBeneficiarios = true,
  canAddConjugue = true,
  isBeneficiariosListActive,
  isBeneficiariosDetailActive,
  isConjugueScreenActive,
  isConjugueFormActive,
  beneficiariosRows,
  selectedBeneficiario,
  beneficiarioDraft,
  beneficiarioFormInitialValues,
  conjugueDisplayValues,
  conjugueSectionControlRef,
  onConjugueActiveSectionChange,
  onEditBeneficiario,
  onAddBeneficiario,
  onBeneficiarioValidityChange,
  onBeneficiarioValuesChange,
  onAddConjugue,
  onEditConjugue,
  onConjugueValidityChange,
  onConjugueValuesChange,
}) => (
  <>
    {!isConjugueScreenActive && isBeneficiariosListActive && (
      <div className="bsds-mt-16" role="region" aria-label="Lista de beneficiários do segurado">
        <BeneficiariosTable
          rows={beneficiariosRows}
          onEdit={onEditBeneficiario}
          onAdd={onAddBeneficiario}
          canEdit={canManageBeneficiarios}
        />
      </div>
    )}

    {!isConjugueScreenActive && isBeneficiariosDetailActive && beneficiarioDraft && (
      <div className="bsds-mt-16">
        <SeguradoBeneficiarioFormSection
          key={`beneficiario-${selectedBeneficiario?.id ?? beneficiarioDraft.localId}-${formKey}`}
          initialValues={beneficiarioFormInitialValues ?? beneficiarioDraft}
          readOnly={!canManageBeneficiarios || isSaving}
          onValidityChange={onBeneficiarioValidityChange}
          onValuesChange={onBeneficiarioValuesChange}
        />
      </div>
    )}

    {isConjugueScreenActive && (
      <ConjuguePanelSection
        conjugueValues={conjugueDisplayValues}
        isAdding={isConjugueFormActive}
        canAdd={canAddConjugue}
        isSaving={isSaving}
        sectionControlRef={conjugueSectionControlRef}
        onActiveSectionChange={onConjugueActiveSectionChange}
        onAdd={onAddConjugue}
        onEdit={onEditConjugue}
        onValidityChange={onConjugueValidityChange}
        onValuesChange={onConjugueValuesChange}
      />
    )}
  </>
);

export default SeguradoRelatedPanelsSection;
